import { Button } from 'components/ui/button';
import { Info } from 'lucide-react';
import AppBar from 'components/AppBar';

/**
 * Dashboard-specific AppBar (breadcrumbs + about action).
 * Prefer importing AppBar directly on other pages.
 */
export default function DashboardAppBar() {
  return (
    <AppBar
      variant="inset"
      breadcrumbs={[
        { label: 'HEP IIB', hideOnMobile: true },
        { label: 'Dashboard' },
      ]}
      actions={
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="app-bar__action"
          title="About this dashboard"
          aria-label="About this dashboard"
        >
          <Info className="h-4 w-4" />
        </Button>
      }
    />
  );
}
